import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @Input() modalId: any;
  @Input() modalSize: string;

  modalSizeConfig: any;

  constructor() {}

  ngOnInit() {
    this.modalSizeConfig = {
      'modal-sm': this.modalSize == 'sm',
      'modal-lg': this.modalSize == 'lg',
      'modal-xl': this.modalSize == 'xl',
    };
  }
}
